import Enumeration from 'Lib/utilities/Enumeration';

const ApplicationFieldTypes = new Enumeration([
    { id: 1, name: 'Text' },
    { id: 2, name: 'State' },
    { id: 3, name: 'Country' },
    { id: 4, name: 'Toggle' },
    { id: 5, name: 'DatePicker' },
    { id: 6, name: 'Radio' },
    { id: 7, name: 'Question' },
    { id: 8, name: 'SocialSecurity' },
    { id: 9, name: 'TextArea' },
    { id: 10, name: 'Term' },
    { id: 11, name: 'DropDown' },
    { id: 12, name: 'Hidden' },
    { id: 13, name: 'Signature' },
    { id: 14, name: 'FileUpload' },
    { id: 15, name: 'Currency' },
    { id: 16, name: 'Integer' },
    { id: 17, name: 'Numeric' },
    { id: 18, name: 'Phone' },
    { id: 19, name: 'Email' }
]);

export default ApplicationFieldTypes;
